module.exports = __webpack_public_path__ + "static/media/gory_sneg_vershina_84607_1920x1080.0b51f8bd.jpg";